module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/folder-heart-377a4ff7e70fb5b99e0c2848503b4cf9.svg";